import React from 'react';
import { Box, Grid, Typography, Container, Button, Stack, useTheme, styled } from '@mui/material';
import back from '../images/teamNew.jpg';
import back1 from '../images/tm.jpg';
import teamMembers from '../data/team.json';

const StyledButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(3),
    padding: theme.spacing(1.5, 4),
    borderRadius: '50px',
    backgroundColor: '#fff',
    color: '#000',
    fontWeight: 'bold',
    textTransform: 'none',
    boxShadow: theme.shadows[3],
    transition: 'background-color 0.3s, transform 0.3s, color 0.3s', // Added 'color 0.3s'
    '&:hover': {
        backgroundColor: '#a974d0', // Changed hover background color
        color: '#fff', // Added hover text color
        transform: 'translateY(-2px)',
    },
}));

function Team() {
  const theme = useTheme();

  return (
    <>
      {/* Hero Section */}
      <Box
        sx={{
          height: { md: '60vh', xs: '40vh' },
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${back})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'white',
          textAlign: 'center',
          p: 2,
        }}
        className='no-select'
      >
        <Typography
          variant="h2"
          component="h1"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontWeight: '600',
            fontSize: { xs: '3rem', md: '6rem' },
            mb: 2,
          }}
        >
          Our Team
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontWeight: '500',
            fontSize: { xs: '0.875rem', md: '1.2rem' },
          }}
        >
          <a href='/' style={{ textDecoration: 'none', color: 'white' }}>Home</a> / <span style={{ color: theme.palette.secondary.main }}>Our Team</span>
        </Typography>
      </Box>

      {/* Team Introduction */}
      <Container maxWidth="lg" sx={{ my: { xs: 8, md: 12 } }}>
        <Stack spacing={2} alignItems={{ xs: 'center', md: 'flex-start' }}>
          <Typography
            variant="h6"
            component="p"
            sx={{
              color: theme.palette.secondary.main,
              fontFamily: "Montserrat, sans-serif",
              fontWeight: '600',
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            Experience. Talent. Unity.
          </Typography>
          <Typography
            variant="h3"
            component="h2"
            sx={{
              color: theme.palette.text.primary,
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 'bold',
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            Meet the expertise in the industry
          </Typography>
        </Stack>
      </Container>
      
      {/* Team Members Grid */}
      <Container maxWidth="lg" sx={{ my: { xs: 8, md: 12 } }}>
        <Grid container spacing={{ xs: 4, md: 6 }}>
          {teamMembers.map((member, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <Box
                sx={{
                  textAlign: 'center',
                  p: 2,
                  transition: 'transform 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-10px)',
                  },
                }}
              >
                <Box
                  sx={{
                    width: '100%',
                    height: 0,
                    paddingBottom: '100%',
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: '50%', // This is the change for the rounded photo frame
                    mb: 2,
                    boxShadow: theme.shadows[4],
                  }}
                >
                  <Box
                    component="img"
                    src={member.image}
                    alt={member.name}
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      transition: 'transform 0.3s ease-in-out',
                      '&:hover': {
                        transform: 'scale(1.05)',
                      },
                    }}
                  />
                </Box>
                <Typography
                  variant="h7"
                  sx={{
                    color: '#a974d0', // This is the change for the team member name color
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: '700',
                    mb: 0.5,
                  }}
                >
                  {member.name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: theme.palette.text.secondary,
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: '600',
                  }}
                >
                  {member.position}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>

      <Box
                sx={{
                    height: '35vh',
                    backgroundImage: `url(${back1})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    color: '#fff',
                }}
            >
                <Box sx={{ p: 2 }}>
                    <Typography
                        variant="h1"
                        sx={{
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: '500',
                            fontSize: { md: '6rem', xs: '4rem' },
                        }}
                    >
                        Let's Start
                    </Typography>
                    <Typography
                                                    variant="h6"
                                                    sx={{
                                                        fontFamily: 'Montserrat, sans-serif',
                                                        fontWeight: '700',
                                                        fontSize: { md: '1.25rem', xs: '1rem' },
                                                        mt: 2
                                                    }}
                                                    >
                                                    Empowering businesses through custom software solutions.{' '}
                                                    <span style={{ color: '#a974d0' }}>Your success, our code.</span>
                                                </Typography>
                    <StyledButton href="/contactus">Get In Touch</StyledButton>
                </Box>
            </Box>
    </>
  );
}

export default Team;